module.exports = __webpack_public_path__ + "static/img/trip.9ce55747.jpg";